import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  header: {
    backgroundColor: designTokens.primary[800],
    borderBottom: "1px solid rgba(255,255,255,0.08)",
    padding: "28px 72px 24px",
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[2],
    transition: `padding ${designTokens.transition.base}`,
  },
  title: {
    color: designTokens.neutral.white,
    fontWeight: designTokens.fontWeight.bold,
    fontSize: designTokens.fontSize["2xl"],
    lineHeight: designTokens.lineHeight.tight,
    margin: "0",
  },
  subtitle: {
    color: "rgba(255,255,255,0.72)",
    fontSize: designTokens.fontSize.xs,
    lineHeight: designTokens.lineHeight.relaxed,
    maxWidth: "620px",
    margin: "0",
    fontWeight: designTokens.fontWeight.normal,
    maxHeight: "60px",
    opacity: "1",
    overflow: "hidden",
    transition: `max-height ${designTokens.transition.base}, opacity ${designTokens.transition.fast}`,
  },
  subtitleCollapsed: {
    maxHeight: "0",
    opacity: "0",
  },
});
